.content {
    /* Padding is a little weird to ensure the 'X' button appears aligned */
    padding: 8px 6px 8px 16px;
    min-height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: var(--font-normal);
}
